import { APPLICANT_DELETE_STR, DRIVER_DELETE_STR } from "common/sf_strings";
import { MODE, REQUIRED_FEATURE_FLAGS, LEAD_TYPE_IDS } from "helpers/sf_constants";
import { optionsCreditRating, optionsGender, optionsLeadEducation, optionsLeadOccupation, optionsLicenseStatus, optionsMaritalStatus, optionsRelationToPrimaryDriver, optionsTrueFalse } from "helpers/sf_lead_constants";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { updateLeadDetails } from "store/leads/actions";
import { addLeadApplicant, deleteLeadApplicant, updateLeadApplicant } from "store/leads/lead_applicants_actions";
import DeleteModal from "../DeleteModal";
import AddDriverModal from "../Modals/AddDriverModal";
import LeadDatePicker from "./LeadDatePicker";
import LeadEditDropdown from "./LeadEditDropdown";
import { getPrimaryTextClass } from "helpers/sf_utils";
import { addProspectApplicant, deleteProspectApplicant, updateProspectApplicant } from "store/prospects/prospects_applicants_actions";
import { updateProspectDetails } from "store/prospects/actions";
import LeadEditDropdownForNumberFields from "./LeadEditDropdownForNumberFields";
import { isAutoOrMotorcycle } from "helpers/sf_leads_calls_helper";
import useFeatureFlags from "hooks/useFeatureFlags";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";

const LeadDrivers = props => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;

    const [driverModal, setDriverModal] = useState({ active: null, values: null });
    const [isFeatureFlagActive] = useFeatureFlags();
    const [deleteDriverModal, setDeleteDriverModal] = useState({ action: false, driver: {} });
    const [lead_data, setLeadData] = useState({})
    const { lead_id } = useParams();
    const { leads } = useSelector(state => ({
        leads: state.Leads.leads,
    }));
    let applicantUpdater = updateLeadApplicant
    let applicantAdder = addLeadApplicant
    let applicantDeleter = deleteLeadApplicant
    let detailsUpdater = updateLeadDetails
    if (props?.is_prospect) {
        applicantUpdater = updateProspectApplicant;
        applicantAdder = addProspectApplicant
        applicantDeleter = deleteProspectApplicant
        detailsUpdater = updateProspectDetails
    }
    const dispatch = useDispatch();
    //Create a useeffect and get lead data from redux store from lead_id from useParams
    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);
        }
    }, [props?.lead_data])

    //Only shows details like first_name and last_name, hides any other
    const hideAddtionalDetails = useMemo(() => {
        return !([LEAD_TYPE_IDS.COMMERCIAL, LEAD_TYPE_IDS.GROUP_HEALTH].includes(lead_data?.lead_type_id))
    }, [lead_data?.lead_type_id])

    const handleLaunchDriverModal = (active, values, mode) => {
        setDriverModal({
            active: active,
            values: { ...values, lead_type_id: lead_data?.lead_type_id },
            mode: mode
        });
    };
    const onSubmitDriverModalState = (mode, values) => {
        if (mode === MODE.EDIT) {
            dispatch(applicantUpdater({ lead_applicant: values }))
            const { id, own_home, bankruptcy } = values;
            const updatedLeadDetails = { id: lead_data?.lead_detail?.id, own_home, bankruptcy };
            dispatch(detailsUpdater({ lead_details: updatedLeadDetails }))
            if (values?.primary_applicant == true) {
                let lead_detail_data = {}
                lead_detail_data.id = lead_data?.lead_detail?.id
                lead_detail_data.first_name = values.first_name
                lead_detail_data.last_name = values.last_name
                dispatch(detailsUpdater({ lead_details: lead_detail_data }))
            }
        } else {
            dispatch(applicantAdder({ ...values, lead_id }));
        }
        setDriverModal({ active: false, values: null })
    }

    // For Delete Driver Modal
    const launchDeleteDriverModal = (driver) => {
        setDeleteDriverModal({ action: true, driver: driver });
    };

    const onClickDriverDelete = (payload) => {
        dispatch(applicantDeleter({ id: payload?.driver?.id }));
        setDeleteDriverModal({ action: false, driver: {} });
    };

    return (
        <React.Fragment>
            <DeleteModal
                deleteModalState={deleteDriverModal}
                onDeleteClick={onClickDriverDelete}
                textMessage={isAutoOrMotorcycle(lead_data?.lead_type_id) ? DRIVER_DELETE_STR : APPLICANT_DELETE_STR}
                onCloseClick={() => setDeleteDriverModal({ action: false, driver: {} })}
                cancelButton
            />
            <AddDriverModal
                onSaveDriverClick={onSubmitDriverModalState}
                onCloseClick={() => setDriverModal({ active: false, values: null })}
                show={driverModal}
                title={isAutoOrMotorcycle(lead_data?.lead_type_id) ? 'Driver' : 'Applicant'}
            />
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                {lead_data?.lead_applicants?.map((driver, idx) => (
                                    <tbody id={idx === 0 ? 'primary-driver' : 'secondary-drivers'} key={idx}>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <Col className="d-flex align-items-end pt-1 my-2">
                                                    <i className={`me-2 bx fs-24 bx-user ${getPrimaryTextClass()}`} />
                                                    <div className="fs-15 me-2 font-weight-semibold">
                                                        {isAutoOrMotorcycle(lead_data?.lead_type_id) ? (idx === 0 ? 'Primary Driver' : `Driver #${idx + 1}`)
                                                            : (idx === 0 ? 'Primary Applicant' : `Applicant #${idx + 1}`)
                                                        }
                                                    </div>
                                                    {!isReadOnly &&
                                                        <div className="ms-1 fs-13 text-sfblue font-weight-semibold align-self-end">
                                                            <a onClick={() => handleLaunchDriverModal(true, {
                                                                ...driver,
                                                                own_home: lead_data?.lead_detail?.own_home,
                                                                bankruptcy: lead_data?.lead_detail?.bankruptcy,
                                                                primary_applicant: idx === 0 ? true : false
                                                            }, MODE.EDIT)}>
                                                                Edit
                                                            </a>
                                                        </div>
                                                    }
                                                </Col>
                                            </td>
                                            <td></td>
                                            <td style={{ width: '33%' }}>
                                                {!isReadOnly && idx !== 0 &&
                                                    <Col className={`${getPrimaryTextClass()} pt-1 my-2 font-weight-semibold`}>
                                                        <div className="d-flex flex-row-reverse">
                                                            <a
                                                                className={`d-flex ${getPrimaryTextClass()}`}
                                                                onClick={() => launchDeleteDriverModal(driver)}
                                                            >
                                                                <i className="mdi mdi-close me-2" />
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </Col>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-top">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        First Name
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='First Name'
                                                            field={driver?.first_name}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = driver?.id
                                                                data.first_name = value
                                                                dispatch(applicantUpdater({ lead_applicant: data }))
                                                                if (idx === 0) {
                                                                    let lead_detail_data = {}
                                                                    lead_detail_data.id = lead_data?.lead_detail?.id
                                                                    lead_detail_data.first_name = value
                                                                    dispatch(detailsUpdater({ lead_details: lead_detail_data }))
                                                                }
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>

                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-top">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Last Name
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Last Name'
                                                            field={driver?.last_name}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = driver?.id
                                                                data.last_name = value
                                                                dispatch(applicantUpdater({ lead_applicant: data }))
                                                                if (idx === 0) {
                                                                    let lead_detail_data = {}
                                                                    lead_detail_data.id = lead_data?.lead_detail?.id
                                                                    lead_detail_data.last_name = value
                                                                    dispatch(detailsUpdater({ lead_details: lead_detail_data }))
                                                                }
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            {hideAddtionalDetails && (
                                                <>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Education
                                                            </Label>
                                                            <div className="d-flex align-items-top">
                                                                <LeadEditDropdown
                                                                    isDropdown={true}
                                                                    options={optionsLeadEducation}
                                                                    title='Education'
                                                                    field={driver?.education}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.education = value,
                                                                            dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Military
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    isBoolean={true}
                                                                    isDropdown={true}
                                                                    options={optionsTrueFalse}
                                                                    title='Military'
                                                                    field={driver?.military_service}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.military_service = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </>
                                            )}


                                        </tr>
                                        {hideAddtionalDetails && (
                                            <>
                                                <tr>

                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Occupation
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    isDropdown={true}
                                                                    options={optionsLeadOccupation}
                                                                    title='Occupation'
                                                                    field={driver?.occupation}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.occupation = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {idx === 0 ?
                                                        <td style={{ width: '33%' }}>
                                                            <div className="d-flex align-items-top">
                                                                <Label className="mb-0 font-weight-semibold me-2">
                                                                    Homeowner
                                                                </Label>
                                                                <div className="d-flex align-items-center">
                                                                    <LeadEditDropdown
                                                                        isBoolean={true}
                                                                        isDropdown={true}
                                                                        options={optionsTrueFalse}
                                                                        title='Homeowner'
                                                                        field={lead_data?.lead_detail?.own_home}
                                                                        onSave={(value) => {
                                                                            let data = {}
                                                                            data.id = lead_data?.lead_detail?.id
                                                                            data.own_home = value
                                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                                        }}
                                                                        onCancel={() => { }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        :
                                                        <td style={{ width: '33%' }}></td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Date of Birth
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadDatePicker
                                                                    title='Date of Birth'
                                                                    field={driver?.dob}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.dob = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Gender
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    isDropdown={true}
                                                                    options={optionsGender}
                                                                    title='Gender'
                                                                    field={driver?.gender}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.gender = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {idx === 0 ?
                                                        <td style={{ width: '33%' }}>
                                                            <div className="d-flex align-items-top">
                                                                <Label className="mb-0 font-weight-semibold me-2">
                                                                    SR22
                                                                </Label>
                                                                <div className="d-flex align-items-center">
                                                                    <LeadEditDropdown
                                                                        isBoolean={true}
                                                                        isDropdown={true}
                                                                        options={optionsTrueFalse}
                                                                        title='SR22'
                                                                        field={driver?.sr_22}
                                                                        onSave={(value) => {
                                                                            let data = {}
                                                                            data.id = driver?.id
                                                                            data.sr_22 = value
                                                                            dispatch(applicantUpdater({ lead_applicant: data }))
                                                                        }}
                                                                        onCancel={() => { }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        :
                                                        <td style={{ width: '33%' }}></td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Marital Status
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    title='Marital Status'
                                                                    isDropdown={true}
                                                                    options={optionsMaritalStatus}
                                                                    field={driver?.marital_status || ''}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.marital_status = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Credit Rating
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    isDropdown={true}
                                                                    options={optionsCreditRating}
                                                                    title='Credit Rating'
                                                                    field={driver?.credit || ''}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.credit = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {idx === 0 ?
                                                        <td style={{ width: '33%' }}>
                                                            <div className="d-flex align-items-top">
                                                                <Label className="mb-0 font-weight-semibold me-2">
                                                                    Bankruptcy
                                                                </Label>
                                                                <div className="d-flex align-items-center">
                                                                    <LeadEditDropdown
                                                                        isBoolean={true}
                                                                        isDropdown={true}
                                                                        options={optionsTrueFalse}
                                                                        title='Bankruptcy'
                                                                        field={lead_data?.lead_detail?.bankruptcy}
                                                                        onSave={(value) => {
                                                                            let data = {}
                                                                            data.id = lead_data?.lead_detail?.id
                                                                            data.bankruptcy = value
                                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                                        }}
                                                                        onCancel={() => { }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        :
                                                        <td style={{ width: '33%' }}></td>
                                                    }
                                                </tr>
                                            </>
                                        )}
                                        {(lead_data?.lead_type_id === 2 || lead_data?.lead_type_id === 3) &&
                                            <tr>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Height(ft)
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdownForNumberFields
                                                                title='Height'
                                                                field={driver?.height_ft}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.height_ft = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Height(in)
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdownForNumberFields
                                                                title='Height'
                                                                field={driver?.height_in}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.height_in = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Weight
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdownForNumberFields
                                                                title='Weight'
                                                                field={driver?.weight + ' lbs'}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.weight = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        {lead_data?.lead_type_id === 2 &&
                                            <tr>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            DUI
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdown
                                                                isBoolean={true}
                                                                isDropdown={true}
                                                                options={optionsTrueFalse}
                                                                title='DUI'
                                                                field={driver?.dui || false}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.dui = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Prescriptions
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdown
                                                                isBoolean={true}
                                                                isDropdown={true}
                                                                options={optionsTrueFalse}
                                                                title='Prescriptions'
                                                                field={!!driver?.medications}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.medications = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Tobacco
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdown
                                                                isBoolean={true}
                                                                isDropdown={true}
                                                                options={optionsTrueFalse}
                                                                title='Tobacco'
                                                                field={!!driver?.tobacco}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.tobacco = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        {hideAddtionalDetails &&
                                            <tr>
                                                {lead_data?.lead_type_id === 3 && <>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Tobacco
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    isBoolean={true}
                                                                    isDropdown={true}
                                                                    options={optionsTrueFalse}
                                                                    title='Tobacco'
                                                                    field={!!driver?.tobacco}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.tobacco = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ width: '33%' }}>
                                                        <div className="d-flex align-items-top">
                                                            <Label className="mb-0 font-weight-semibold me-2">
                                                                Pre-existing conditions
                                                            </Label>
                                                            <div className="d-flex align-items-center">
                                                                <LeadEditDropdown
                                                                    isBoolean={true}
                                                                    isDropdown={true}
                                                                    options={optionsTrueFalse}
                                                                    title='Pre-existing conditions'
                                                                    field={!!driver?.has_pre_existing_conditions}
                                                                    onSave={(value) => {
                                                                        let data = {}
                                                                        data.id = driver?.id
                                                                        data.has_pre_existing_conditions = value
                                                                        dispatch(applicantUpdater({ lead_applicant: data }))
                                                                    }}
                                                                    onCancel={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </>}
                                                {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_HOUSEHOLD_COLUMN_FOR_LEAD_DETAILS_PAGE) && [LEAD_TYPE_IDS.HEALTH, LEAD_TYPE_IDS.LIFE].includes(lead_data?.lead_type_id) && idx === 0 &&
                                                    <td style={{ cursor: 'default' }}>
                                                        <div>
                                                            <Label className="mb-0 font-weight-semibold">
                                                                Household Income
                                                            </Label>
                                                            <p className="mb-0">{lead_data?.lead_detail?.household_income_range || '--'}</p>
                                                        </div>
                                                    </td>
                                                }
                                            </tr>}


                                        {isAutoOrMotorcycle(lead_data?.lead_type_id) &&
                                            <tr>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            License Status
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdown
                                                                isDropdown={true}
                                                                options={optionsLicenseStatus}
                                                                title='License Status'
                                                                field={driver?.license_status || ''}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.license_status = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '33%' }}>
                                                    <div className="d-flex align-items-top">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Relationship
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdown
                                                                isDropdown={true}
                                                                options={optionsRelationToPrimaryDriver}
                                                                title='Relationship'
                                                                field={driver?.relation}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = driver?.id
                                                                    data.relation = value
                                                                    dispatch(applicantUpdater({ lead_applicant: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: '33%' }}>
                                                </td>
                                            </tr>
                                        }

                                    </tbody>
                                ))}
                            </Table>
                        </div>
                        {!isReadOnly &&
                            <div className="text-sfblue font-weight-semibold mt-4">
                                {isAutoOrMotorcycle(lead_data?.lead_type_id) ? <a onClick={() => handleLaunchDriverModal(true, null, MODE.CREATE)}>
                                    + Add Driver
                                </a> :
                                    <a onClick={() => handleLaunchDriverModal(true, null, MODE.CREATE)}>
                                        + Add Applicant
                                    </a>
                                }
                            </div>
                        }
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadDrivers